import React from 'react';
import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="relative z-20 bg-[#0a0a0a] py-4 px-8 w-full">
      <div className="max-w-7xl mx-auto w-full">
        {/* First row - Logo and Icons on mobile, 3-col grid on desktop */}
        <div className="mb-4">
          {/* Mobile: Logo left, Icons right */}
          <div className="flex md:hidden justify-between items-start mb-8">
            <div>
              <div className="inline-flex items-end gap-2 mb-2">
                <div className="flex flex-col text-white text-xl font-bold text-right" style={{ lineHeight: '0.85' }}>
                  <span>schmal</span>
                  <span>gs<span className="text-pink-500">ich</span>t</span>
                </div>
                <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-pink-500 rounded-2xl flex items-center justify-center">
                  <span className="text-white text-lg font-bold">v2</span>
                </div>
              </div>
              <p className="text-gray-400 text-sm">
                Neuer. Besser. Ich.
              </p>
            </div>

            {/* Contact and Instagram - Mobile */}
            <div className="flex gap-4 items-center">
              <a href="mailto:kontakt@schmalsoft.de" className="text-gray-400 hover:text-white transition-colors">
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                </svg>
              </a>
              <a href="https://www.instagram.com/schmalgsichtfm/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Desktop: 3-column grid */}
          <div className="hidden md:grid md:grid-cols-3 gap-8 items-center">
            {/* Logo and subtitle */}
            <div>
              <div className="inline-flex items-end gap-3 mb-2">
                <div className="flex flex-col text-white text-2xl font-bold text-right" style={{ lineHeight: '0.85' }}>
                  <span>schmal</span>
                  <span>gs<span className="text-pink-500">ich</span>t</span>
                </div>
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-pink-500 rounded-2xl flex items-center justify-center">
                  <span className="text-white text-xl font-bold">v2</span>
                </div>
              </div>
              <p className="text-gray-400 text-sm mb-4">
                Neuer. Besser. Ich.
              </p>
            </div>

            {/* Made with love - centered */}
            <div className="flex justify-center">
              <div className="flex items-center gap-3">
                <p className="text-gray-400 text-sm">Made with <span className="text-red-500">❤️</span> von</p>

                {/* Robert */}
                <div className="flex items-center gap-2">
                  <img
                    src="/Robert_cover.jpg"
                    alt="Robert"
                    className="w-12 h-12 rounded-full border-2 border-white"
                  />
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-pink-500 font-semibold text-sm">
                    Robert
                  </span>
                </div>

                <span className="text-gray-400 text-sm">&</span>

                {/* Yoshy */}
                <div className="flex items-center gap-2">
                  <img
                    src="/Yoshy_cover.jpg"
                    alt="Yoshy"
                    className="w-12 h-12 rounded-full border-2 border-white"
                  />
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-pink-500 font-semibold text-sm">
                    Yoshy
                  </span>
                </div>
              </div>
            </div>

            {/* Contact and Instagram */}
            <div className="flex gap-4 items-center justify-end">
              <a href="mailto:kontakt@schmalsoft.de" className="text-gray-400 hover:text-white transition-colors">
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                </svg>
              </a>
              <a href="https://www.instagram.com/schmalgsichtfm/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Made with love - Mobile only, below logo row */}
          <div className="flex md:hidden justify-center">
            <div className="flex flex-col items-center gap-2">
              <p className="text-gray-400 text-sm">Made with <span className="text-red-500">❤️</span> von</p>

              <div className="flex items-center gap-3">
                {/* Robert */}
                <div className="flex items-center gap-2">
                  <img
                    src="/Robert_cover.jpg"
                    alt="Robert"
                    className="w-12 h-12 rounded-full border-2 border-white"
                  />
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-pink-500 font-semibold text-sm">
                    Robert
                  </span>
                </div>

                <span className="text-gray-400 text-sm">&</span>

                {/* Yoshy */}
                <div className="flex items-center gap-2">
                  <img
                    src="/Yoshy_cover.jpg"
                    alt="Yoshy"
                    className="w-12 h-12 rounded-full border-2 border-white"
                  />
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-pink-500 font-semibold text-sm">
                    Yoshy
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-4 flex flex-col sm:flex-row justify-between items-center gap-2">
          <p className="text-gray-400 text-sm">© 2026 schmalsoft solutions. Alle Rechte vorbehalten.</p>

          {/* Impressum */}
          <Link to="/impressum" className="text-gray-400 hover:text-white transition-colors text-sm">
            Impressum
          </Link>
        </div>
      </div>
    </footer>
  );
}
